var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('div', {
    class: _vm.$style.viewContainer
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('BaseTitle', [_vm._v("Home")]), _c('div', {
    class: _vm.$style.homeContainer
  }, [_c('div', {
    class: _vm.$style.favoriteColumn
  }, [_c('div', {
    class: _vm.$style.carouselWrapper
  }, [_c('h3', [_vm._v("Favorite Apps")]), !_vm.favoriteApps.length ? _c('p', {
    staticClass: "color-dark-gray text-center"
  }, [_vm._v(" Go to Apps and click the heart to favorite an app. ")]) : _vm._e(), _c('div', {
    class: _vm.$style.appBlockContainer
  }, [_c('transition-group', _vm._l(_vm.favoriteApps, function (app) {
    return _c('div', {
      key: app.appId
    }, [_c('AppBlock', {
      class: _vm.$style.appBlock,
      attrs: {
        "name": app.appName,
        "description": app.description,
        "category": app.category,
        "card-image": app.cardImage,
        "card-image-mobile": app.cardImageMobile,
        "app-url": app.appUrl,
        "app-id": app.appId,
        "options": {
          forceMobileDesign: true
        }
      }
    }), _c('AppTag', {
      class: _vm.$style.appTag,
      attrs: {
        "category": app.category
      }
    })], 1);
  }), 0)], 1)]), _c('div', {
    class: _vm.$style.carouselWrapper
  }, [_c('h3', [_vm._v("Favorite Resources")]), !_vm.favoriteResources.length ? _c('p', {
    staticClass: "color-dark-gray text-center"
  }, [_vm._v(" Go to Resources and click the heart to favorite a resource. ")]) : _vm._e(), _vm.favoriteResources.length && !_vm.isMobile ? _c('carousel', {
    ref: "resourcesCarousel",
    class: _vm.$style.carousel,
    attrs: {
      "per-page-custom": _vm.perPageResourceCarousel,
      "pagination-enabled": false,
      "navigation-enabled": true,
      "navigation-next-label": '',
      "navigation-prev-label": ''
    }
  }, _vm._l(_vm.favoriteResources, function (resource) {
    return _c('slide', {
      key: resource.resourceId
    }, [_c('div', {
      class: _vm.$style.resourceBlockContainer
    }, [_c('ResourceBlock', {
      attrs: {
        "resource": resource,
        "minimal-design": true
      }
    })], 1)]);
  }), 1) : _vm._e(), _vm.favoriteResources.length && _vm.isMobile ? _c('div', {
    class: _vm.$style.mobileCarousel
  }, _vm._l(_vm.favoriteResources, function (resource) {
    return _c('div', {
      key: resource.resourceId,
      class: _vm.$style.resourceBlockContainer
    }, [_c('ResourceBlock', {
      attrs: {
        "resource": resource,
        "minimal-design": true
      }
    })], 1);
  }), 0) : _vm._e()], 1), _c('div', {
    class: _vm.$style.carouselWrapper
  }, [_c('h3', [_vm._v("Favorite Events")]), !_vm.favoriteEvents.length ? _c('p', {
    staticClass: "color-dark-gray text-center"
  }, [_vm._v(" Select a calendar day to view Events, then click the flag to favorite an event. ")]) : _vm._e(), _vm.favoriteEvents.length && !_vm.isMobile ? _c('carousel', {
    ref: "eventCarousel",
    class: _vm.$style.carousel,
    attrs: {
      "per-page-custom": _vm.perPageEventCarousel,
      "pagination-enabled": false,
      "navigation-enabled": true,
      "navigation-next-label": '',
      "navigation-prev-label": ''
    }
  }, _vm._l(_vm.getFavoriteEventsOrdered, function (event) {
    return _c('slide', {
      key: event.eventId
    }, [_c('div', {
      class: _vm.$style.eventBlockContainerInCarousel
    }, [_c('EventBlock', {
      key: event.eventId,
      attrs: {
        "event": event,
        "minimal-design": true
      }
    })], 1)]);
  }), 1) : _vm._e(), _vm.favoriteEvents.length && _vm.isMobile ? _c('div', {
    class: _vm.$style.mobileCarousel
  }, _vm._l(_vm.getFavoriteEventsOrdered, function (event) {
    return _c('div', {
      key: event.eventId,
      class: _vm.$style.eventBlockContainerInCarousel
    }, [_c('EventBlock', {
      key: event.eventId,
      attrs: {
        "event": event,
        "minimal-design": true
      }
    })], 1);
  }), 0) : _vm._e()], 1)]), _c('div', {
    class: _vm.$style.eventsColumn,
    attrs: {
      "data-event-column": ""
    }
  }, [_c('h3', {
    staticClass: "m-0"
  }, [_vm._v("Events")]), _c('div', {
    staticClass: "mt-3 d-flex justify-content-around"
  }, [_c('BaseSelect', {
    class: _vm.$style.eventBaseSelect,
    attrs: {
      "empty-text": "All Meeting Types",
      "name": "MeetingType",
      "options": ['Live', 'Virtual', 'Hybrid']
    },
    model: {
      value: _vm.selectedMeetingType,
      callback: function callback($$v) {
        _vm.selectedMeetingType = $$v;
      },
      expression: "selectedMeetingType"
    }
  }), _c('BaseSelect', {
    class: _vm.$style.eventBaseSelect,
    attrs: {
      "empty-text": "All Audiences",
      "name": "AudienceType",
      "options": _vm.getAudienceOptions
    },
    model: {
      value: _vm.selectedAudience,
      callback: function callback($$v) {
        _vm.selectedAudience = $$v;
      },
      expression: "selectedAudience"
    }
  })], 1), _c('div', {
    staticClass: "mt-3 d-flex justify-content-around"
  }, [_c('SelectEventType', {
    attrs: {
      "selected-event-type-prop": _vm.selectedEventType
    },
    on: {
      "update:selectedEventTypeProp": function updateSelectedEventTypeProp($event) {
        _vm.selectedEventType = $event;
      },
      "update:selected-event-type-prop": function updateSelectedEventTypeProp($event) {
        _vm.selectedEventType = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "mt-3 mb-3",
    class: _vm.$style.divider
  }), _c('MottoCalendar', {
    class: _vm.$style.calendar,
    attrs: {
      "events": _vm.getAllEventsFiltered,
      "selected-date-prop": _vm.selectedDate
    },
    on: {
      "update:selectedDateProp": function updateSelectedDateProp($event) {
        _vm.selectedDate = $event;
      },
      "update:selected-date-prop": function updateSelectedDateProp($event) {
        _vm.selectedDate = $event;
      },
      "updateDate": _vm.selectDate
    }
  }), _c('div', {
    staticClass: "mt-3 mb-4",
    class: _vm.$style.divider
  }), !_vm.selectedDate ? [_c('h3', [_vm._v("Upcoming Events")]), _c('div', {
    class: _vm.$style.eventBlockContainer
  }, [_vm._l(_vm.getUpcomingEvents, function (event) {
    return _c('EventBlock', {
      key: event.eventId,
      attrs: {
        "current-date": _vm.selectedDate ? _vm.selectedDate : new Date(),
        "event": event
      }
    });
  }), !_vm.getUpcomingEvents.length ? _c('p', {
    staticClass: "text-center tag-text"
  }, [_vm._v("No upcoming events")]) : _vm._e()], 2)] : _vm._e(), _vm.selectedDate ? [_c('h3', [_vm._v("Events on " + _vm._s(_vm.getSelectedDateFormatted))]), _c('div', {
    class: _vm.$style.eventBlockContainer
  }, [_vm._l(_vm.getEventsOnSelectedDate, function (event) {
    return _c('EventBlock', {
      key: event.eventId,
      attrs: {
        "current-date": _vm.selectedDate ? _vm.selectedDate : new Date(),
        "event": event
      }
    });
  }), !_vm.getEventsOnSelectedDate.length ? _c('p', {
    staticClass: "text-center tag-text"
  }, [_vm._v("No events on this date")]) : _vm._e()], 2)] : _vm._e()], 2)])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "view-resource-modal",
      "modal-class": ['right', 'modal-resource'],
      "hide-footer": "",
      "hide-header": "",
      "title": "BootstrapVue"
    }
  }, [_c('ModalResource', {
    attrs: {
      "toast-component": this.$bvToast
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "view-event-modal",
      "modal-class": ['right', 'modal-event'],
      "hide-footer": "",
      "hide-header": "",
      "title": "BootstrapVueEvent"
    }
  }, [_c('ModalEvent', {
    attrs: {
      "toast-component": this.$bvToast
    }
  })], 1), _c('ModalOptInMobilePrompt', {
    attrs: {
      "mobile-number": _vm.currentUser.phoneMobile
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }